import React, { useState } from "react";
import EnvelopeIntro from "./components/EnvelopeIntro";
import SudokuGrid from "./components/SudokuGrid";
import Quiz from "./components/Quiz";
import ImagePuzzle from "./components/ImagePuzzle";
import Proposal from "./components/Proposal";

const App = () => {
  const [isEnvelopeOpened, setIsEnvelopeOpened] = useState(false);
  const [isSudokuSolved, setIsSudokuSolved] = useState(false);
  const [isQuizPassed, setIsQuizPassed] = useState(false);
  const [isImagePuzzleSolved, setIsImagePuzzleSolved] = useState(false);

  return (
    <div>
      {!isEnvelopeOpened ? (
        <EnvelopeIntro onOpened={() => setIsEnvelopeOpened(true)} />
      ) : !isSudokuSolved ? (
        <SudokuGrid setIsSudokuSolved={setIsSudokuSolved} />
      ) : !isQuizPassed ? (
        <Quiz onPassed={() => setIsQuizPassed(true)} />
      ) : !isImagePuzzleSolved ? (
        <ImagePuzzle onSolved={() => setIsImagePuzzleSolved(true)} />
      ) : (
        <Proposal />
      )}
    </div>
  );
};

export default App;
